/* istanbul ignore file */

export const FORM_FIELDS = {
  STATUS_FILTER: 'statusFilter',
  WEBSITES_FILTER: 'websitesFilter',
  CONTENT_TYPE_FILTER: 'contentTypeFilter',
  MODIFIED_FILTER: 'modifiedFilter',
  TOPIC_FILTER: 'topicFilter',
  AUTHOR_FILTER: 'authorFilter',
  CONTENT_SEARCH_FILTER: 'contentSearchFilter',
};
